import Image from 'next/image';
import React from 'react';

import { cn } from '@/utils/styles';

import { KeyValuePreviewProps } from './key-value-preview.types';

export const KeyValuePreview = React.memo(({ data }: KeyValuePreviewProps) => {
  return (
    <div
      className={cn(
        'bg-NeutralLightLight h-10 max-h-96 px-6 py-4 flex flex-col items-start text-left overflow-y-scroll flex-1 border-NeutralLightMedium border-y gap-y-4',
      )}>
      {data && Object.entries(data).length > 0 ? (
        Object.entries(data).map(([key, value]) => (
          <div key={key} className='flex items-center gap-x-3 w-full'>
            <div className='flex flex-none px-1.5 py-1 bg-BackgroundBlueGray text-HighlightDarkPlus rounded'>
              <Image
                className='opacity-75'
                src='/imgs/icons/customCode.svg'
                alt='Custom code icon'
                width={12}
                height={12}
              />
              <span className='mx-2 text-xs text-ellipsis overflow-hidden'>{key}</span>
            </div>
            <div className='text-sm align-top text-pretty w-full'>{JSON.stringify(value)}</div>
          </div>
        ))
      ) : (
        <p className='text-sm text-NeutralDarkMedium'>No data available</p>
      )}
    </div>
  );
});

KeyValuePreview.displayName = 'KeyValuePreview';
